import * as Yup from 'yup';

import {
  yupMinField,
  yupRequiredField,
} from '../../../../../utils/helpers/yup';
import { TransportEntitiesType } from '../../TransportEntities.functions';

export type Coordinates = [number, number];

export type CreateTransportEntitiesType = {
  barcode: string;
  transportEntityType: {
    id: number;
    name?: string;
  };
  ownerLogisticsPoint: {
    id: number;
    name?: string;
  };
  currentLogisticsPoint: {
    id: number;
    name?: string;
  };
  // destinationLogisticsPoint: {
  //   id: number;
  //   name?: string;
  // };
  volume: number;
};

export function getDefaultValues(
  isEditDialog: boolean,
  transportEntity: TransportEntitiesType | undefined
) {
  return {
    barcode: isEditDialog ? transportEntity?.barcode ?? '' : '',
    transportEntityType: isEditDialog
      ? transportEntity?.transportEntityType ?? { id: 1 }
      : { id: 1 },
    ownerLogisticsPoint: isEditDialog
      ? transportEntity?.ownerLogisticsPoint ?? { id: 0 }
      : { id: 0 },
    currentLogisticsPoint: isEditDialog
      ? transportEntity?.currentLogisticsPoint ?? { id: 0 }
      : { id: 0 },
    // destinationLogisticsPoint: isEditDialog
    //   ? transportEntity?.destinationLogisticsPoint ?? { id: 0 }
    //   : { id: 0 },
    volume: isEditDialog ? transportEntity?.volume ?? 1 : 1,
  };
}

export function getValidationSchema(t: any) {
  return Yup.object().shape({
    barcode: Yup.string()
      .required(yupRequiredField(t, t('Barcode')))
      .min(1, ({ min }) => yupMinField(t, t('Barcode'), min)),
    transportEntityType: Yup.object({
      id: Yup.number().required(
        yupRequiredField(t, t('Transport Entity Type'))
      ),
      name: Yup.string().optional(),
    }).required(yupRequiredField(t, t('Transport Entity Type'))),
    ownerLogisticsPoint: Yup.object({
      id: Yup.number().required(
        yupRequiredField(t, t('Owner Logistics Point'))
      ),
      name: Yup.string().optional(),
    }).required(yupRequiredField(t, t('Owner Logistics Point'))),
    currentLogisticsPoint: Yup.object({
      id: Yup.number().required(
        yupRequiredField(t, t('Current Logistics Point'))
      ),
      name: Yup.string().optional(),
    }).required(yupRequiredField(t, t('Current Logistics Point'))),
    // destinationLogisticsPoint: Yup.object({
    //   id: Yup.number().required(
    //     yupRequiredField(t, t('Destination Logistics Point'))
    //   ),
    //   name: Yup.string().optional(),
    // }).required(yupRequiredField(t, t('Destination Logistics Point'))),
    volume: Yup.number()
      .required(yupRequiredField(t, t('Volume')))
      .min(1, ({ min }) => yupMinField(t, t('Volume'), min)),
  });
}

// export function toApiData(values: any) {
//   let apiData: any = {
//     ...values,
//   };

//   apiData.barcode = values.barcode;
//   apiData.volume = values.volume;
//   apiData.volume = values.volume;

//   return apiData;
// }
